import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/test-asdf',
      name: 'test',
      component: () => import('@/views/error/Test.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/oauth/:type',
      name: 'oauth',
      component: () => import('@/views/Oauth.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'الرئيسية',
        layout: 'full',
      },
    },
    {
      path: '/admin',
      name: 'dashboard',
      component: () => import('@/views/admin/Dashboard.vue'),
      meta: {
        requireLogin: true,
        only_admin: true,
        pageTitle: 'لوحة القيادة',
        breadcrumb: [
          {
            text: 'الرئيسية',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/users',
      name: 'users',
      component: () => import('@/views/admin/users/UsersList.vue'),
      meta: {
        pageTitle: 'العملاء',
        requireLogin: true,
        only_admin: true,
      },
    },
    {
      path: '/admin/users/:id',
      name: 'user-details',
      component: () => import('@/views/admin/users/UserDetails.vue'),
      meta: {
        pageTitle: 'العملاء',
        requireLogin: true,
        only_admin: true,
        breadcrumb: [
          {
            text: 'بيانات العميل',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admin/users/:user_id/create-template',
      name: 'admin-create-template',
      component: () => import('@/views/admin/templates/CreateTemplate.vue'),
      meta: {
        requireLogin: true,
        only_admin: true,
      },
    },
    {
      path: '/admin/users/:user_id/templates/:template_id',
      name: 'admin-template',
      component: () => import('@/views/admin/templates/Template.vue'),
      meta: {
        requireLogin: true,
        only_admin: true,
      },
    },
    {
      path: '/admin/offer/categories',
      name: 'offer-category',
      component: () => import('@/views/admin/offers/Category.vue'),
      meta: {
        requireLogin: true,
        only_admin: true,
      },
    },
    {
      path: '/admin/offer/offers',
      name: 'offers',
      component: () => import('@/views/admin/offers/Offers.vue'),
      meta: {
        requireLogin: true,
        only_admin: true,
      },
    },
    {
      path: '/admin/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      component: () => import('@/views/Campaigns.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/offers',
      name: 'user-offers',
      component: () => import('@/views/Plans.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/templates',
      name: 'templates',
      component: () => import('@/views/Templates.vue'),
      meta: {
        layout: 'full',
        requireLogin: true,
      },
    },
    {
      path: '/templates/:id',
      name: 'template-details',
      component: () => import('@/views/Template.vue'),
      meta: {
        requireLogin: true,
        layout: 'full',
      },
    },
    {
      path: '/create-template',
      name: 'create-template',
      component: () => import('@/views/CreateTemplate.vue'),
      meta: {
        requireLogin: true,
        layout: 'full',
      },
    },
    {
      path: '/welcome-salla.php',
      name: 'welcome-salla',
      component: () => import('@/views/WelcomeSalla.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/welcome-zid.php',
      name: 'welcome-zid',
      component: () => import('@/views/WelcomeZid.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/welcome-shopify',
      name: 'welcome-shopify',
      component: () => import('@/views/WelcomeShopify.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/install-shopify',
      name: 'install-shopify',
      component: () => import('@/views/InstallShopify.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/welcome-woocommerce',
      name: 'welcome-woocommerce',
      component: () => import('@/views/WelcomeWoocommerce.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/setup',
      name: 'setup',
      component: () => import('@/views/Setup.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/views/Signup.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/signin',
      name: 'signin',
      component: () => import('@/views/SignIn.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/welcome-success',
      name: 'welcome-success',
      component: () => import('@/views/SignupSuccess.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/plans',
      name: 'plans',
      component: () => import('@/views/Plans.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/salla-disconnect',
      name: 'salla-disconnect',
      component: () => import('@/views/error/DisconnectSalla.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/zid-disconnect',
      name: 'zid-disconnect',
      component: () => import('@/views/error/DisconnectZid.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/invalid-subscription',
      name: 'invalid-subscription',
      component: () => import('@/views/error/Subscription.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/salla-conversation',
      name: 'salla-conversation',
      component: () => import('@/views/SallaConversation.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/customer',
      name: 'customer',
      component: () => import('@/views/Customer.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/public/app/coupons/:id',
      name: 'coupon-app',
      component: () => import('@/views/public/CustomerCoupon'),
      meta: {
        requireLogin: false,
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  // handle access
  if (to.matched.some(record => record.meta.requireLogin) && !store.state.auth.isAuthenticated) {
    // console.log('access');
    if (store.state.auth.user.is_admin == 1 ){
      return next({name: 'login'})
    } else {
      return next({name: 'home'})
    }
  } else {
    next()
  }
})


// check permission
router.beforeEach((to, _, next) => {
  // handle access
  if (to.matched.some(record => record.meta.only_admin) && store.state.auth.user.is_admin != 1) {
    // console.log('permissio');
    return next({name: 'login'})
  } else {
    next()
  }
})


// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
